export default {
      id: "entry-n-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#entry-n",
      toString: function () {
        return this.url;
      }
    }